import { useEffect, type ReactNode } from 'react'
import { useRouter } from 'next/router'

import { Spinner } from '@wartek-id/spinner'
import { useToast } from '@wartek-id/toast'

import { PENGELOLAAN_KINERJA_PAMONG_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { usePelaksanaanDate } from 'app/KinerjaShared/hooks/usePelaksanaanDate'

type PageGuardPamongPelaksanaanDateProps = {
  children?: ReactNode
}

export function PageGuardPamongPelaksanaanDate({
  children,
}: PageGuardPamongPelaksanaanDateProps) {
  const toast = useToast()
  const router = useRouter()

  const { isStarted, isResolved } = usePelaksanaanDate()

  useEffect(() => {
    // If the pelaksanaan date for the current period hasn't started yet, redirect to the Pamong pegawai homepage
    if (isResolved && !isStarted) {
      router.replace(PENGELOLAAN_KINERJA_PAMONG_PEGAWAI_PATH)
      toast({
        message:
          'Tahap Pelaksanaan dan Penilaian belum dimulai untuk periode tersebut.',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isResolved, isStarted])

  if (!isResolved || !isStarted) {
    return (
      <div className="flex py-20 justify-center">
        <Spinner />
      </div>
    )
  }

  return <>{children}</>
}
